import { getCompanyInfo } from '@ils/config/project-config.js';
import { getAllowedPageKeys } from '@ils/permissions/pagePermission.js';
import type { Pages } from '@ils/permissions/permissions.js';
import { ExamType } from '@ils/static/enums.js';

export interface pageType {
  pageKey: string;
  description: string;
  page: string;
  icon?: string;
  location: string;
  params?: any;
  customURL?: string;
}

export const pages: Record<Pages, pageType> = {
  signup: {
    pageKey: 'signup',
    description: 'Kaufe Prüfungen',
    page: 'signup',
    icon: 'shopping_cart',
    location: 'general',
    params: null,
    // TODO how to get ExamType for currentUser?
    customURL: getCompanyInfo(ExamType.FAMED).signupUrl,
  },
  dashboard: {
    pageKey: 'candidate_dashboard',
    description: 'Alle Funktionen im Überblick',
    page: 'dashboard',
    icon: 'dashboard',
    location: 'specific',
  },
  scheduling: {
    pageKey: 'scheduling',
    description: 'Übersicht über alle verfügbaren Prüfungen',
    page: 'scheduling',
    icon: 'alarm',
    location: 'specific',
    params: null,
  },
  'check-in': {
    pageKey: 'check_in',
    description: ' asdf asdf',
    page: 'check-in',
    icon: 'assignment_turned_in',
    location: 'invisible',
    params: null,
  },
  spectate: {
    pageKey: 'spectate',
    description: '',
    page: 'spectate',
    icon: 'visibility',
    location: 'invisible',
    params: null,
  },
  exam: {
    pageKey: 'exam',
    description: 'Die Prüfungsseite für die aktuell laufende Prüfung',
    page: 'exam',
    icon: 'book',
    location: 'specific',
    params: null,
  },
  examTrainee: {
    pageKey: 'exam_trainee',
    description: 'Die Prüfungsseite für die aktuell laufende Prüfung',
    page: 'exam',
    icon: 'book',
    location: 'invisible',
    params: null,
  },
  'tester-dashboard': {
    pageKey: 'tester_dashboard',
    description: 'Alle Funktionen im Überblick',
    page: 'tester-dashboard',
    icon: 'dashboard',
    location: 'specific',
  },
  users: {
    pageKey: 'users',
    description: 'Übersicht über alle registrierten User',
    page: 'users',
    icon: 'manage_accounts',
    location: 'general',
    params: null,
  },
  locations: {
    pageKey: 'locations',
    description: 'Übersicht über alle registrierten Standorte',
    page: 'locations',
    icon: 'location_on',
    location: 'general',
    params: null,
  },
  soundcheck: {
    pageKey: 'soundcheck',
    description: 'Soundcheck für Schauspieler',
    page: 'soundcheck',
    icon: 'video_call',
    location: 'invisible',
    params: null,
  },
  start: { pageKey: 'start', description: '', page: 'start', location: 'invisible', params: null },
  'editor-osce': {
    pageKey: 'osce_editor',
    description: '',
    page: 'editor-osce',
    location: 'general',
    icon: 'drive_file_rename_outline',
    params: null,
  },
  'editor-osce-group': {
    pageKey: 'osce_editor_group',
    description: '',
    page: 'editor-osce-group',
    location: 'invisible',
    icon: 'drive_file_rename_outline',
    params: null,
  },
  'content-osce': {
    pageKey: 'content_osce',
    description: '',
    page: 'content-osce',
    icon: 'content_paste',
    location: 'general',
    params: null,
  },
  'editor-exam': {
    pageKey: 'exam_editor',
    description: '',
    page: 'editor-exam',
    location: 'general',
    icon: 'edit',
    params: null,
  },
  mails: {
    pageKey: 'mails',
    description: 'E-Mail Templates Editieren',
    page: 'mails',
    icon: 'email',
    location: 'general',
    params: null,
  },
  'evaluation-overview': {
    pageKey: 'evaluation_overview',
    description: 'Übersicht über alle verfügbaren Bewertungen',
    page: 'evaluation-overview',
    icon: 'grading',
    location: 'specific',
    params: null,
  },
  evaluation: {
    pageKey: 'evaluation',
    description: '',
    page: 'evaluation',
    icon: 'grading',
    location: 'invisible',
    params: null,
  },
  'evaluation-timeallocation': {
    pageKey: 'evaluation_timeallocation',
    description: '',
    page: 'evaluation-timeallocation',
    icon: 'event_available',
    location: 'specific',
    params: null,
  },
  'evaluation-async': {
    pageKey: 'evaluation_async',
    description: 'Festlegen von Zeitrahmen fpr die Terminfindung von Synchronen Bewertungen',
    page: 'evaluation-async',
    icon: 'grading',
    location: 'invisible',
    params: null,
  },
  'evaluation-sync': {
    pageKey: 'evaluation_sync',
    description: '',
    page: 'evaluation-sync',
    icon: 'grading',
    location: 'invisible',
    params: null,
  },
  'evaluation-termin': {
    pageKey: 'evaluation_termin',
    description: '',
    page: 'evaluation-termin',
    icon: 'grading',
    location: 'invisible',
    params: null,
  },
  'local-recordings': {
    pageKey: 'local_recordings',
    description:
      'Übersicht über alle lokal gespeicherten Prüfungsmitschnitte und ob diese bereits zum Server hochgeladen wurden',
    page: 'local-recordings',
    icon: 'mic',
    location: 'specific',
    params: null,
  },
  export: {
    pageKey: 'export',
    description: '',
    page: 'export',
    icon: 'export_notes',
    location: 'general',
    params: null,
  },
  'evaluation-reported-errors': {
    pageKey: 'reported_errors',
    description: 'Übersicht über alle während der Bewertung gemeldeten Fehler in Antworten',
    page: 'evaluation-reported-errors',
    icon: 'cloud_off',
    location: 'general',
    params: null,
  },
};

const sideBarOrder = [
  'scheduling',
  'evaluation_overview',
  'evaluation-timeallocation',
  'users',
  'osce_editor',
  'content_osce',
  'exam_editor',
  'locations',
  'mails',
  'reported_errors',
  'export',
];

export const getUserAllowedPages = (user: { _id: string; roles: { name: string; contexts: string[] }[] }) => {
  return getAllowedPageKeys(user)
    .map(pageKey => pages[pageKey] as pageType)
    .sort((a, b) => {
      const aIndex = sideBarOrder.findIndex(orderItem => orderItem === a.pageKey);
      const bIndex = sideBarOrder.findIndex(orderItem => orderItem === b.pageKey);

      // Items not found in the order array go to the end
      if (aIndex === -1 && bIndex === -1) return 0;
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;

      return aIndex - bIndex;
    });
};
